import {
    ChangeDetectionStrategy,
    Component,
    inject,
    input,
    InputSignal,
    model,
    output,
    OutputEmitterRef,
    WritableSignal,
} from "@angular/core";
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import { ThemeService } from "../../_services/theme.service";

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    selector: "app-shared-left-menu",
    standalone: true,
    imports: [FaIconComponent],
    templateUrl: "./left-menu.component.html",
    styleUrl: "./left-menu.component.scss",
})
export class SharedLeftMenuComponent {
    private readonly themeService: ThemeService = inject(ThemeService);

    public isVisible = model<boolean>(false);
    public alwaysVisible: InputSignal<boolean> = input<boolean>(false);
    public signOut: OutputEmitterRef<void> = output<void>();

    readonly theme: WritableSignal<string> = model<string>("light");

    constructor() {
        this.themeService.theme$.subscribe((theme) => {
            this.theme.set(theme);
        });
    }

    toggleVisibility(): void {
        if (this.alwaysVisible()) {
            return;
        }
        this.isVisible.set(!this.isVisible());
    }

    toggleTheme(): void {
        this.themeService.toggleTheme();
    }
}
